/**
 * 에러 처리 관련 유틸리티 함수들
 */

/**
 * API 에러에서 메시지를 추출하는 함수
 * 
 * @param error - API 에러 객체
 * @returns {string} 에러 메시지
 */
export const getErrorMessage = (error: any): string => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }
  if (error.message) {
    return error.message;
  }
  return '알 수 없는 오류가 발생했습니다.';
};

/**
 * 에러 메시지를 표시하는 함수
 * 
 * @param message - 표시할 에러 메시지
 */
export const showErrorMessage = (message: string): void => {
  // message.error는 antd의 message 컴포넌트를 사용
  // 실제 사용 시에는 message.error(message)로 호출
};

/**
 * 로그인 관련 에러 타입을 판단하는 함수
 * 
 * @param error - API 에러 객체
 * @returns {'credentials' | 'network' | 'server' | 'unknown'} 에러 타입
 */
export const getLoginErrorType = (error: any): 'credentials' | 'network' | 'server' | 'unknown' => {
  if (error.response?.status === 401) {
    return 'credentials';
  }
  if (error.code === 'NETWORK_ERROR' || error.message?.includes('Network Error')) {
    return 'network';
  }
  if (error.response?.status >= 500) {
    return 'server';
  }
  return 'unknown';
};

/**
 * 데이터 로딩 실패 메시지를 생성하는 함수
 * 
 * @param dataType - 데이터 타입 (예: '규범류', '공지사항', '입법예고' 등)
 * @returns {string} 에러 메시지
 */
export const getLoadErrorMessage = (dataType: string): string => {
  return `${dataType}을(를) 불러오는데 실패했습니다.`;
};

/**
 * 데이터 저장 실패 메시지를 생성하는 함수
 * 
 * @param dataType - 데이터 타입 (예: '규범류', '공지사항', '입법예고' 등)
 * @returns {string} 에러 메시지
 */
export const getSaveErrorMessage = (dataType: string): string => {
  return `${dataType}을(를) 저장하는데 실패했습니다.`;
};

/**
 * 데이터 삭제 실패 메시지를 생성하는 함수
 * 
 * @param dataType - 데이터 타입 (예: '규범류', '공지사항', '입법예고' 등)
 * @returns {string} 에러 메시지
 */
export const getDeleteErrorMessage = (dataType: string): string => {
  return `${dataType}을(를) 삭제하는데 실패했습니다.`;
}; 